<template>
  <router-view />
</template>

<script>
export default {
  name: 'User.MessageManagement'
}
</script>

<style scoped>

</style>
